module.exports = __webpack_public_path__ + "media/42.fff0aa56.mp3";